import { axios } from "../../helper/axios";
import { ConnectorConstant } from "./ConnectorConstant";

const ConnectorApiData = {};
ConnectorApiData.getConnectorData = (data) => {
 
  let { filter, search_term, page, limit,from_date,to_date } = data;
  let queryParam = "";

 
  if (from_date !== undefined && from_date !== null) {
    queryParam += `startDate=${from_date}&`;
  }
  if (to_date !== undefined && to_date !== null) {
    queryParam += `endDate=${to_date}&`;
  }
  if (page) {
    queryParam += `page=${page}&`;
  }
  if (limit !== undefined && limit !== null) {
    queryParam += `limit=${limit}&`;
  }
  if (filter !== undefined && filter !== null) {
    queryParam += `filter=${filter}&`;
  }
  if (search_term !== undefined && search_term !== null) {
    queryParam += `search_term=${search_term}&`;
  }

  return axios.get(`${ConnectorConstant.CONNECTOR_API}?${queryParam}&page=${1}`);
};

ConnectorApiData.getbulkexceConnectorDataApi = (data) => {
 
  let {  page, limit } = data;
  let queryParam = "";

 

  if (page) {
    queryParam += `page=${page}&`;
  }
  if (limit !== undefined && limit !== null) {
    queryParam += `limit=${limit}&`;
  }
  
  return axios.get(`${ConnectorConstant.CONNECTOR_BULK_EXCEL_API}?${queryParam}&page=${1}`);
};




ConnectorApiData.postConnectorData = (payload) => {
  return axios.post(ConnectorConstant.ADD_CONNECTOR_API, payload);
};
ConnectorApiData.postBulkData = (file) => {
  
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(ConnectorConstant.POST_CONNECTOR_BULK_API, formData);
};
ConnectorApiData.DeleteConnectorApi = ({ id }) => {
  
  return axios.delete(
    ConnectorConstant.DELETE_CONNECTOR_API.replace(":id", id)
  );
};


ConnectorApiData.editConnectorApi = (payload,id) => {

  return axios.put(ConnectorConstant.EDIT_CONNECTOR_API.replace(":id", id), payload);
};


export { ConnectorApiData };
